// src/components/shells/AppRouteFallback.jsx
import React from "react";
import "../../styles/skeletons.css";

export default function AppRouteFallback() {
  return (
    <div className="route-fallback-shell" aria-hidden="true">
      <div className="route-fallback-topbar">
        <div className="route-fallback-chip skeleton-shimmer" />
        <div className="route-fallback-line skeleton-shimmer" />
      </div>

      <div className="route-fallback-card">
        <div className="route-fallback-title skeleton-shimmer" />
        <div className="route-fallback-block skeleton-shimmer" />
        <div className="route-fallback-block skeleton-shimmer" />
        <div className="route-fallback-block short skeleton-shimmer" />
      </div>
    </div>
  );
}